// @ts-nocheck
export default function usePagination(aliases, aliasesPerPage){
    const pageCount = Math.ceil(aliases.length/aliasesPerPage);

    const paginateAliases = (aliasesCopy, currentPage) => {
        return aliasesCopy.sort().slice((currentPage - 1) * aliasesPerPage, aliasesPerPage*currentPage);
    }
    
    return {pageCount, paginateAliases};
}